<script setup>
import { ref, computed } from 'vue'
import { useAlarmState } from '../composables/AlarmState.js'

const props = defineProps({
  canClear: {
    type: Boolean,
    default: false
  },
  canContinue: {
    type: Boolean,
    default: true
  },
});

const emit = defineEmits([ "clear", "continue" ]);

function clear() {
  clearAlarm();
  emit("clear");
}

function continueAction() {
  emit("continue");
}

const {
  isHaltAlarm,
  isCurtainAlarm,
  isDisruptAlarm,
  clearAlarm
} = useAlarmState();
</script>

<template>
  <!-- persistent not-escapable -->
  <Modal id="alarmWindow" size="3xl" class="non-escapable-modal dark:bg-gray-900">
    <template #header>
      <div class="flex items-center text-lg dark:text-white">
        Prekinitev
      </div>
    </template>
    <template #body>
      <div class="grid place-items-center w-full gap-8 mb-4 dark:text-white" style="min-height: 250px; max-height: 1000px;">

        <div>
          <div class="text-center">
            Zaznana je bila prekinitev.
          </div>

          <div class="text-center font-bold text-red-500 mt-2">
            <div v-if="isHaltAlarm">
              <i class="fa fa-exclamation-triangle mr-2"></i>Ročna zaustavitev
            </div>
            <div v-if="isCurtainAlarm">
              <i class="fa fa-exclamation-triangle mr-2"></i>Prekinjena zavesa
            </div>
            <div v-if="isDisruptAlarm">
              <i class="fa fa-exclamation-triangle mr-2"></i>Prekinitev napajanja na krmilniku
            </div>
          </div>

        </div>

      </div>
    </template>
    <template #footer>
      <div class="flex justify-end gap-2 w-full" style="min-height: 30px;">
        <Button type="secondary" @click="clear()" v-if="canClear">Prekliči</Button>
        <Button type="primary" :enabled="true" @click="continueAction()" v-if="canContinue">Nadaljuj</Button>
      </div>
    </template>
  </Modal>
</template>